// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","454":"c6adfd01"}[chunkId] + ".chunk.js";
};